// Copyright (c) Move Closer 2022.

import { AsyncComponent } from 'vue'

import { resolveCTAModuleContent } from '../CTABox/CTABox.helpers'
import { resolveImageModuleContent } from '../Image/Image.helpers'
import { resolveNavigationCTABoxModuleContent } from '../NavigationCTABox/NavigationCTABox.helpers'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export enum NavbarModuleVersion {
  Default = 'default',
  Simple = 'simple'
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const navbarModuleVersionComponentRegistry: Record<string, AsyncComponent> = {
  [NavbarModuleVersion.Default]: () => import(
    /* webpackChunkName: "modules/NavbarDefault" */
    './versions/Default/Default.vue'
  ),
  [NavbarModuleVersion.Simple]: () => import(
    /* webpackChunkName: "modules/NavbarSimple" */
    './versions/Simple/Simple.vue'
  )
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export type PossibleSnippet = string

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const PossibleSnippets: Record<PossibleSnippet, string> = {
  CTABox: 'cta_box',
  Image: 'image',
  NavigationCTABox: 'navigation_cta_box'
  // possible product modules in the future
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const resolversMap = {
  [PossibleSnippets.CTABox]: resolveCTAModuleContent,
  [PossibleSnippets.Image]: resolveImageModuleContent,
  [PossibleSnippets.NavigationCTABox]: resolveNavigationCTABoxModuleContent
}
